// === MAGICAL KIDS WEBSITE - MAIN JAVASCRIPT === //

// === CONFIGURATION === //
const CONFIG = {
    animations: {
        enabled: true,
        duration: 1000,
        easing: 'ease-in-out'
    },
    gallery: {
        autoplay: true,
        loop: true,
        speed: 500
    },
    sounds: {
        enabled: false, // Can be enabled later
        volume: 0.3
    }
};

// === GLOBAL STATE === //
let isLoading = true;
let currentSection = 'home';
let gallerySwiper = null;

// === DOM ELEMENTS === //
const elements = {
    loader: document.getElementById('loader'),
    navbar: document.getElementById('navbar'),
    navMenu: document.getElementById('nav-menu'),
    navToggle: document.getElementById('nav-toggle'),
    heroName: document.getElementById('heroName'),
    photoCount: document.getElementById('photoCount'),
    artCount: document.getElementById('artCount'),
    adventureCount: document.getElementById('adventureCount'),
    contactForm: document.getElementById('contactForm'),
    galleryModal: document.getElementById('galleryModal')
};

// === INITIALIZATION === //
document.addEventListener('DOMContentLoaded', function() {
    console.log('🌟 Initializing Magical Kids Website...');
    
    // Apply configuration first
    applyConfiguration();
    
    // Retry configuration after a short delay if needed
    setTimeout(() => {
        if (typeof WEBSITE_CONFIG !== 'undefined') {
            applyConfiguration();
        }
    }, 100);
    
    initializeLoader();
    initializeNavigation();
    initializeAnimations();
    initializeGallery();
    initializeContactForm();
    initializeDynamicContent();
    initializeScrollEffects();
    initializeInteractiveElements();
    initializeThemeToggle();
    initializeAppsEditor();
    
    // Hide loader after everything is ready
    setTimeout(() => {
        hideLoader();
    }, 2000);
    
    console.log('✨ Website ready! Let the magic begin!');
});

// === WINDOW LOAD FALLBACK === //
window.addEventListener('load', function() {
    console.log('🔄 Window loaded - ensuring configuration is applied...');
    if (typeof WEBSITE_CONFIG !== 'undefined') {
        applyConfiguration();
    }
});

// === CONFIGURATION APPLICATION === //
function applyConfiguration() {
    console.log('🔧 Applying configuration...');
    
    if (typeof WEBSITE_CONFIG === 'undefined') {
        console.error('❌ WEBSITE_CONFIG is not defined! Check if config.js loaded properly.');
        return;
    }
    
    console.log('✅ WEBSITE_CONFIG found:', WEBSITE_CONFIG.child.name);
    
    // Apply personal information
    const heroName = document.getElementById('heroName');
    const heroAge = document.getElementById('heroAge');
    const heroBio = document.getElementById('heroBio');
    
    console.log('🔍 Found elements:', { heroName: !!heroName, heroAge: !!heroAge, heroBio: !!heroBio });
    
    if (heroName) {
        heroName.textContent = WEBSITE_CONFIG.child.name;
        console.log('✅ Updated hero name to:', WEBSITE_CONFIG.child.name);
    }
    if (heroAge) {
        heroAge.textContent = `Age ${WEBSITE_CONFIG.child.age}`;
        console.log('✅ Updated hero age to:', WEBSITE_CONFIG.child.age);
    }
    if (heroBio) {
        heroBio.textContent = WEBSITE_CONFIG.child.bio;
        console.log('✅ Updated hero bio');
    }
    
    // Update page title
    document.title = `🌟 ${WEBSITE_CONFIG.child.name}'s Creative World 🌟`;
    
    // Apply theme colors
    applyThemeColors();
    
    // Update contact information
    updateContactInfo();
    
    // Update social links
    updateSocialLinks();
    
    // Update statistics
    updateStatsFromDatabase();
    
    console.log(`✨ Configuration applied for ${WEBSITE_CONFIG.child.name}!`);
}

function applyThemeColors() {
    if (!WEBSITE_CONFIG.theme) return;
    
    const root = document.documentElement;
    root.style.setProperty('--primary-pink', WEBSITE_CONFIG.theme.primaryColor);
    root.style.setProperty('--primary-purple', WEBSITE_CONFIG.theme.secondaryColor);
    root.style.setProperty('--primary-blue', WEBSITE_CONFIG.theme.accentColor);
    
    // Update manifest theme color
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
        themeColorMeta.setAttribute('content', WEBSITE_CONFIG.theme.primaryColor);
    }
}

function updateContactInfo() {
    if (!WEBSITE_CONFIG.contact) return;
    
    // Update contact email
    const emailElements = document.querySelectorAll('[data-email]');
    emailElements.forEach(el => {
        el.textContent = WEBSITE_CONFIG.contact.email;
    });
    
    // Update location
    const locationElements = document.querySelectorAll('[data-location]');
    locationElements.forEach(el => {
        el.textContent = WEBSITE_CONFIG.contact.location;
    });
    
    // Update fun fact
    const funFactElements = document.querySelectorAll('[data-fun-fact]');
    funFactElements.forEach(el => {
        el.textContent = WEBSITE_CONFIG.child.funFact;
    });
}

function updateSocialLinks() {
    if (!WEBSITE_CONFIG.social) return;
    
    Object.keys(WEBSITE_CONFIG.social).forEach(platform => {
        const config = WEBSITE_CONFIG.social[platform];
        const linkElement = document.querySelector(`.social-link.${platform}`);
        
        if (linkElement) {
            if (config.enabled) {
                linkElement.href = config.url;
                linkElement.style.display = 'flex';
                const textSpan = linkElement.querySelector('span');
                if (textSpan) textSpan.textContent = config.displayName;
            } else {
                linkElement.style.display = 'none';
            }
        }
    });
}

function updateStatsFromDatabase() {
    if (typeof getPhotoStats === 'function') {
        const stats = getPhotoStats();
        
        const photoCount = document.getElementById('photoCount');
        const artCount = document.getElementById('artCount');
        const adventureCount = document.getElementById('adventureCount');
        
        if (photoCount) animateNumber(photoCount, stats.photos);
        if (artCount) animateNumber(artCount, stats.creations);
        if (adventureCount) animateNumber(adventureCount, stats.adventures);
    }
}

// === LOADER FUNCTIONS === //
function initializeLoader() {
    if (!elements.loader) return;
    
    // Add some fun loading messages
    const loadingMessages = [
        'Loading Magic... ✨',
        'Preparing Colors... 🌈',
        'Setting up Adventures... 🚀',
        'Making Everything Sparkle... ⭐',
        'Almost Ready... 🎨'
    ];
    
    const loadingText = document.querySelector('.loading-text');
    let messageIndex = 0;
    
    const messageInterval = setInterval(() => {
        if (loadingText && messageIndex < loadingMessages.length - 1) {
            messageIndex++;
            loadingText.textContent = loadingMessages[messageIndex];
        }
    }, 400);
    
    // Clear interval when loading is done
    setTimeout(() => {
        clearInterval(messageInterval);
    }, 2000);
}

function hideLoader() {
    if (elements.loader) {
        elements.loader.classList.add('hidden');
        document.body.style.overflow = 'auto';
        isLoading = false;
        
        // Trigger entrance animations
        setTimeout(() => {
            triggerEntranceAnimations();
        }, 500);
    }
}

// === NAVIGATION === //
function initializeNavigation() {
    // Mobile menu toggle
    if (elements.navToggle && elements.navMenu) {
        elements.navToggle.addEventListener('click', toggleMobileMenu);
    }
    
    // Smooth scrolling for navigation links
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        link.addEventListener('click', handleSmoothScroll);
    });
    
    // Navbar scroll effect
    window.addEventListener('scroll', handleNavbarScroll);
    
    // Close mobile menu when clicking outside
    document.addEventListener('click', handleOutsideClick);
}

function toggleMobileMenu() {
    elements.navToggle.classList.toggle('active');
    elements.navMenu.classList.toggle('active');
    
    // Prevent body scroll when menu is open
    if (elements.navMenu.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
}

function handleSmoothScroll(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');
    const targetSection = document.querySelector(targetId);
    
    if (targetSection) {
        // Close mobile menu if open
        closeMobileMenu();
        
        // Smooth scroll to section
        targetSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        
        // Update current section
        currentSection = targetId.substring(1);
        updateActiveNavLink(targetId);
    }
}

function handleNavbarScroll() {
    if (!elements.navbar) return;
    
    if (window.scrollY > 50) {
        elements.navbar.classList.add('scrolled');
    } else {
        elements.navbar.classList.remove('scrolled');
    }
}

function handleOutsideClick(e) {
    if (!elements.navMenu || !elements.navToggle) return;
    
    if (elements.navMenu.classList.contains('active') && 
        !elements.navMenu.contains(e.target) && 
        !elements.navToggle.contains(e.target)) {
        closeMobileMenu();
    }
}

function closeMobileMenu() {
    if (elements.navToggle && elements.navMenu) {
        elements.navToggle.classList.remove('active');
        elements.navMenu.classList.remove('active');
        document.body.style.overflow = 'auto';
    }
}

function updateActiveNavLink(targetId) {
    document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === targetId) {
            link.classList.add('active');
        }
    });
}

// === ANIMATIONS === //
function initializeAnimations() {
    // Initialize AOS (Animate On Scroll)
    if (typeof AOS !== 'undefined') {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-in-out',
            offset: 100
        });
    }
    
    // Add custom scroll reveal animations
    initializeScrollReveal();
    
    // Add interactive hover effects
    addInteractiveEffects();
}

function triggerEntranceAnimations() {
    // Hero section animations
    const heroElements = document.querySelectorAll('.hero-content > *');
    heroElements.forEach((element, index) => {
        setTimeout(() => {
            element.style.opacity = '1';
            element.style.transform = 'translateY(0)';
        }, index * 200);
    });
}

function initializeScrollReveal() {
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
            }
        });
    }, observerOptions);
    
    // Observe all elements with scroll-reveal classes
    document.querySelectorAll('.scroll-reveal, .scroll-reveal-left, .scroll-reveal-right').forEach(el => {
        observer.observe(el);
    });
}

function addInteractiveEffects() {
    // Add sparkle effects to buttons
    document.querySelectorAll('.btn').forEach(btn => {
        btn.addEventListener('mouseenter', createSparkleEffect);
    });
    
    // Add wiggle effect to emoji elements
    document.querySelectorAll('.shape').forEach(shape => {
        shape.addEventListener('mouseenter', () => {
            shape.style.animation = 'wiggle 0.5s ease-in-out';
        });
        
        shape.addEventListener('animationend', () => {
            shape.style.animation = '';
        });
    });
}

function createSparkleEffect(e) {
    const button = e.target;
    const sparkle = document.createElement('span');
    sparkle.innerHTML = '✨';
    sparkle.style.position = 'absolute';
    sparkle.style.pointerEvents = 'none';
    sparkle.style.animation = 'sparkle 0.6s ease-out forwards';
    sparkle.style.left = Math.random() * button.offsetWidth + 'px';
    sparkle.style.top = Math.random() * button.offsetHeight + 'px';
    
    button.style.position = 'relative';
    button.appendChild(sparkle);
    
    setTimeout(() => {
        if (sparkle.parentNode) {
            sparkle.parentNode.removeChild(sparkle);
        }
    }, 600);
}

// === GALLERY SYSTEM === //
function initializeGallery() {
    // Initialize album cards
    document.querySelectorAll('.album-card').forEach(card => {
        card.addEventListener('click', handleAlbumClick);
    });
    
    // Initialize gallery modal close
    const galleryClose = document.querySelector('.gallery-close');
    if (galleryClose) {
        galleryClose.addEventListener('click', closeGallery);
    }
    
    // Close gallery on outside click
    if (elements.galleryModal) {
        elements.galleryModal.addEventListener('click', (e) => {
            if (e.target === elements.galleryModal) {
                closeGallery();
            }
        });
    }
}

function handleAlbumClick(e) {
    const albumType = this.dataset.album;
    const albumTitle = this.querySelector('h3').textContent;
    
    openGallery(albumType, albumTitle);
}

function openGallery(albumType, albumTitle) {
    if (!elements.galleryModal) return;
    
    // Set gallery title
    const galleryTitleEl = document.getElementById('galleryTitle');
    if (galleryTitleEl) {
        galleryTitleEl.textContent = albumTitle;
    }
    
    // Load gallery images
    loadGalleryImages(albumType);
    
    // Show modal
    elements.galleryModal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Initialize or update Swiper
    initializeSwiper();
}

function loadGalleryImages(albumType) {
    const galleryWrapper = document.getElementById('galleryWrapper');
    if (!galleryWrapper) return;
    
    // Sample images for demonstration
    const sampleImages = generateSampleImages(albumType);
    
    galleryWrapper.innerHTML = '';
    sampleImages.forEach((img, index) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        slide.innerHTML = `
            <img src="${img.src}" alt="${img.alt}" loading="lazy">
            <div class="image-caption">${img.caption}</div>
        `;
        galleryWrapper.appendChild(slide);
    });
    
    // Update count
    const galleryCount = document.getElementById('galleryCount');
    if (galleryCount) {
        galleryCount.textContent = `1 of ${sampleImages.length}`;
    }
}

function generateSampleImages(albumType) {
    const imageData = {
        family: PHOTO_DATABASE.family.map(photo => ({
            src: photo.src,
            alt: photo.title,
            caption: photo.description
        })),
        school: PHOTO_DATABASE.school.map(photo => ({
            src: photo.src,
            alt: photo.title,
            caption: photo.description
        })),
        hobbies: PHOTO_DATABASE.hobbies.map(photo => ({
            src: photo.src,
            alt: photo.title,
            caption: photo.description
        })),
        special: PHOTO_DATABASE.special.map(photo => ({
            src: photo.src,
            alt: photo.title,
            caption: photo.description
        }))
    };
    
    return imageData[albumType] || imageData.family;
}

function initializeSwiper() {
    if (gallerySwiper) {
        gallerySwiper.destroy(true, true);
    }
    
    if (typeof Swiper !== 'undefined') {
        gallerySwiper = new Swiper('.gallery-swiper', {
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            keyboard: {
                enabled: true,
            },
            on: {
                slideChange: function() {
                    const galleryCount = document.getElementById('galleryCount');
                    const totalSlides = this.slides.length - 2; // Excluding cloned slides
                    const currentSlide = this.realIndex + 1;
                    
                    if (galleryCount) {
                        galleryCount.textContent = `${currentSlide} of ${totalSlides}`;
                    }
                }
            }
        });
    }
}

function closeGallery() {
    if (elements.galleryModal) {
        elements.galleryModal.classList.remove('active');
        document.body.style.overflow = 'auto';
        
        if (gallerySwiper) {
            gallerySwiper.destroy(true, true);
            gallerySwiper = null;
        }
    }
}

// === CONTACT FORM === //
function initializeContactForm() {
    if (!elements.contactForm) return;
    
    elements.contactForm.addEventListener('submit', handleContactSubmit);
    
    // Add character counter for message field
    const messageField = document.getElementById('message');
    if (messageField) {
        addCharacterCounter(messageField);
    }
}

function handleContactSubmit(e) {
    e.preventDefault();
    
    const formData = new FormData(elements.contactForm);
    const data = Object.fromEntries(formData);
    
    // Show loading state
    const submitBtn = elements.contactForm.querySelector('button[type="submit"]');
    const originalText = submitBtn.innerHTML;
    submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Sending...';
    submitBtn.disabled = true;
    
    // Simulate form submission (replace with actual API call)
    setTimeout(() => {
        showNotification('Thank you! Your message has been sent! 🌟', 'success');
        elements.contactForm.reset();
        
        // Reset button
        submitBtn.innerHTML = originalText;
        submitBtn.disabled = false;
    }, 2000);
    
    console.log('Form submitted:', data);
}

function addCharacterCounter(textarea) {
    const maxLength = 500;
    const counter = document.createElement('div');
    counter.className = 'character-counter';
    counter.style.textAlign = 'right';
    counter.style.fontSize = '0.8rem';
    counter.style.color = 'var(--gray)';
    counter.style.marginTop = '5px';
    
    const updateCounter = () => {
        const remaining = maxLength - textarea.value.length;
        counter.textContent = `${remaining} characters remaining`;
        counter.style.color = remaining < 50 ? 'var(--primary-orange)' : 'var(--gray)';
    };
    
    textarea.setAttribute('maxlength', maxLength);
    textarea.addEventListener('input', updateCounter);
    textarea.parentNode.appendChild(counter);
    updateCounter();
}

// === DYNAMIC CONTENT === //
function initializeDynamicContent() {
    loadCreationsGrid();
    loadAdventuresTimeline();
    loadAppsGrid();
    updateStatNumbers();
    personalizeContent();
}

function loadCreationsGrid() {
    const creationsGrid = document.querySelector('.creations-grid');
    if (!creationsGrid) return;
    
    const config = WEBSITE_CONFIG.photos;
    let creations = [];
    
    // Get creations from database
    for (const type in CREATIONS_DATABASE) {
        CREATIONS_DATABASE[type].forEach(creation => {
            creations.push({
                type: type,
                title: creation.title,
                image: creation.src,
                description: creation.description
            });
        });
    }
    
    // If no creations exist and placeholder photos are enabled, generate placeholders
    if (creations.length === 0 && config.usePlaceholderPhotos) {
        creations = generatePlaceholderCreations();
    }
    
    creationsGrid.innerHTML = creations.map(creation => `
        <div class="creation-item" data-filter="${creation.type}" data-aos="fade-up">
            <div class="creation-card">
                <div class="creation-image">
                    <img src="${creation.image}" alt="${creation.title}" loading="lazy">
                    <div class="creation-overlay">
                        <button class="view-creation-btn" onclick="viewCreation('${creation.title}', '${creation.image}', '${creation.description}')">
                            <i class="fas fa-eye"></i>
                        </button>
                    </div>
                </div>
                <div class="creation-info">
                    <h4>${creation.title}</h4>
                    <p>${creation.description}</p>
                </div>
            </div>
        </div>
    `).join('');
    
    // Initialize filter functionality
    initializeCreationFilters();
}

function initializeCreationFilters() {
    const filterBtns = document.querySelectorAll('.filter-btn');
    const creationItems = document.querySelectorAll('.creation-item');
    
    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const filter = btn.dataset.filter;
            
            // Update active button
            filterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            
            // Filter items
            creationItems.forEach(item => {
                if (filter === 'all' || item.dataset.filter === filter) {
                    item.style.display = 'block';
                    setTimeout(() => {
                        item.style.opacity = '1';
                        item.style.transform = 'scale(1)';
                    }, 50);
                } else {
                    item.style.opacity = '0';
                    item.style.transform = 'scale(0.8)';
                    setTimeout(() => {
                        item.style.display = 'none';
                    }, 300);
                }
            });
        });
    });
}

function generatePlaceholderCreations() {
    return [
        {
            type: 'drawings',
            title: 'Rainbow Unicorn',
            image: 'https://picsum.photos/300/300?random=21',
            description: 'My favorite magical creature! 🦄🌈'
        },
        {
            type: 'crafts',
            title: 'Paper Flowers',
            image: 'https://picsum.photos/300/300?random=22',
            description: 'Made these for Mom! 🌸'
        },
        {
            type: 'paintings',
            title: 'Sunset Landscape',
            image: 'https://picsum.photos/300/300?random=23',
            description: 'Painted during art class! 🌅'
        },
        {
            type: 'digital',
            title: 'Space Adventure',
            image: 'https://picsum.photos/300/300?random=24',
            description: 'Created on the tablet! 🚀'
        },
        {
            type: 'drawings',
            title: 'Family Portrait',
            image: 'https://picsum.photos/300/300?random=25',
            description: 'Everyone together! 👨‍👩‍👦'
        },
        {
            type: 'crafts',
            title: 'Friendship Bracelet',
            image: 'https://picsum.photos/300/300?random=26',
            description: 'For my best friend! 💕'
        }
    ];
}

function loadAdventuresTimeline() {
    const adventuresTimeline = document.querySelector('.adventures-timeline');
    if (!adventuresTimeline) return;
    
    const config = WEBSITE_CONFIG.photos;
    let adventures = ADVENTURES_DATABASE.map(adventure => ({
        date: adventure.date,
        title: adventure.title,
        description: adventure.description,
        image: adventure.photos && adventure.photos.length > 0 ? adventure.photos[0] : 'assets/avatar-placeholder.svg'
    }));
    
    // If no adventures exist and placeholder photos are enabled, generate placeholders
    if (adventures.length === 0 && config.usePlaceholderPhotos) {
        adventures = generatePlaceholderAdventures();
    }
    
    adventuresTimeline.innerHTML = adventures.map((adventure, index) => `
        <div class="adventure-item ${index % 2 === 0 ? 'left' : 'right'}" data-aos="fade-${index % 2 === 0 ? 'right' : 'left'}">
            <div class="adventure-card">
                <div class="adventure-image">
                    <img src="${adventure.image}" alt="${adventure.title}" loading="lazy">
                </div>
                <div class="adventure-content">
                    <div class="adventure-date">${formatDate(adventure.date)}</div>
                    <h4>${adventure.title}</h4>
                    <p>${adventure.description}</p>
                </div>
            </div>
        </div>
    `).join('');
}

function generatePlaceholderAdventures() {
    return [
        {
            date: '2024-01-15',
            title: 'Zoo Adventure',
            description: 'Saw amazing animals and learned about lions! 🦁',
            image: 'https://picsum.photos/400/300?random=27'
        },
        {
            date: '2024-02-20',
            title: 'Museum Discovery',
            description: 'Dinosaurs are so cool! Saw a T-Rex! 🦕',
            image: 'https://picsum.photos/400/300?random=28'
        },
        {
            date: '2024-03-10',
            title: 'Beach Day',
            description: 'Built the biggest sandcastle ever! 🏰',
            image: 'https://picsum.photos/400/300?random=29'
        },
        {
            date: '2024-04-05',
            title: 'Camping Trip',
            description: 'Slept under the stars and roasted marshmallows! ⭐',
            image: 'https://picsum.photos/400/300?random=30'
        }
    ];
}

function loadAppsGrid() {
    const appsGrid = document.querySelector('.apps-grid');
    if (!appsGrid) return;
    
    // Get apps from database (reload from storage to get latest)
    let apps = [];
    
    if (typeof loadAppsFromStorage === 'function') {
        apps = loadAppsFromStorage();
        // Update global variable
        if (typeof window !== 'undefined') {
            window.APPS_DATABASE = apps;
        }
    } else if (typeof APPS_DATABASE !== 'undefined' && APPS_DATABASE.length > 0) {
        apps = APPS_DATABASE;
    }
    
    if (apps.length === 0) {
        appsGrid.innerHTML = `
            <div class="no-apps-message">
                <div class="no-apps-icon">🚀</div>
                <h3>More Apps Coming Soon!</h3>
                <p>I'm working on building amazing apps and websites. Check back soon!</p>
            </div>
        `;
        return;
    }
    
    appsGrid.innerHTML = apps.map(app => `
        <div class="app-tile" data-category="${app.category}" data-aos="zoom-in">
            <a href="${app.url}" 
               target="${app.openInNewTab !== false ? '_blank' : '_self'}" 
               rel="noopener noreferrer"
               class="app-link">
                <div class="app-tile-inner">
                    <div class="app-image-container">
                        ${app.image ? 
                            `<img src="${app.image}" alt="${app.name}" class="app-image" loading="lazy" onerror="this.onerror=null; this.style.display='none'; this.parentElement.querySelector('.app-placeholder-fallback').style.display='flex';">` :
                            ''
                        }
                        <div class="app-placeholder app-placeholder-fallback" style="display: ${app.image ? 'none' : 'flex'};">
                            ${app.icon || '💻'}
                        </div>
                        <div class="app-overlay">
                            <div class="app-icon-large">${app.icon || '💻'}</div>
                            <span class="app-visit-text">Visit App →</span>
                        </div>
                    </div>
                    <div class="app-info">
                        <h3 class="app-name">${app.name}</h3>
                        <p class="app-description">${app.description}</p>
                        <div class="app-meta">
                            <span class="app-category-badge">${getCategoryLabel(app.category)}</span>
                            ${app.dateCreated ? `<span class="app-date">${formatDate(app.dateCreated)}</span>` : ''}
                        </div>
                        ${app.tags && app.tags.length > 0 ? `
                            <div class="app-tags">
                                ${app.tags.slice(0, 3).map(tag => `<span class="app-tag">#${tag}</span>`).join('')}
                            </div>
                        ` : ''}
                    </div>
                </div>
            </a>
        </div>
    `).join('');
    
    // Initialize filter functionality
    initializeAppsFilters();
}

function getCategoryLabel(category) {
    const labels = {
        games: "🎮 Games",
        websites: "🌐 Websites",
        tools: "🛠️ Tools",
        creative: "🎨 Creative",
        learning: "📚 Learning"
    };
    return labels[category] || category;
}

function initializeAppsFilters() {
    const filterBtns = document.querySelectorAll('.apps-filters .filter-btn');
    const appTiles = document.querySelectorAll('.app-tile');
    
    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const filter = btn.dataset.filter;
            
            // Update active button
            filterBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            
            // Filter tiles
            appTiles.forEach(tile => {
                if (filter === 'all' || tile.dataset.category === filter) {
                    tile.style.display = 'block';
                    setTimeout(() => {
                        tile.style.opacity = '1';
                        tile.style.transform = 'scale(1)';
                    }, 50);
                } else {
                    tile.style.opacity = '0';
                    tile.style.transform = 'scale(0.8)';
                    setTimeout(() => {
                        tile.style.display = 'none';
                    }, 300);
                }
            });
        });
    });
}

function updateStatNumbers() {
    // Animate counting up numbers
    animateNumber(elements.photoCount, 50);
    animateNumber(elements.artCount, 25);
    animateNumber(elements.adventureCount, 15);
}

// === APPS EDITOR FUNCTIONS === //

function initializeAppsEditor() {
    // Add event listener to edit button
    const editBtn = document.getElementById('editAppsBtn');
    if (editBtn) {
        editBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log('🔘 Edit button clicked!');
            toggleAppsEditor();
        });
        console.log('✅ Apps editor button initialized');
    } else {
        console.warn('⚠️ Edit apps button not found, retrying...');
        // Try again after a delay in case DOM isn't ready
        setTimeout(() => {
            const retryBtn = document.getElementById('editAppsBtn');
            if (retryBtn) {
                retryBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    console.log('🔘 Edit button clicked (retry)!');
                    toggleAppsEditor();
                });
                console.log('✅ Apps editor button initialized (retry)');
            } else {
                console.error('❌ Edit apps button still not found after retry');
            }
        }, 500);
    }
}

function toggleAppsEditor() {
    console.log('🔧 toggleAppsEditor called');
    const modal = document.getElementById('appsEditorModal');
    console.log('Modal element:', modal);
    if (modal) {
        const isActive = modal.classList.contains('active');
        modal.classList.toggle('active');
        console.log('Modal active class:', !isActive);
        
        // Prevent body scroll when modal is open
        if (!isActive) {
            document.body.style.overflow = 'hidden';
            loadAppsEditor();
        } else {
            document.body.style.overflow = 'auto';
        }
    } else {
        console.error('❌ Apps editor modal not found!');
    }
}

function closeAppsEditor() {
    const modal = document.getElementById('appsEditorModal');
    if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = 'auto';
    }
}

function loadAppsEditor() {
    console.log('📝 Loading apps editor...');
    const container = document.getElementById('appsListContainer');
    if (!container) {
        console.error('❌ Apps list container not found!');
        return;
    }
    
    // Try to get apps from storage
    let apps = [];
    if (typeof window !== 'undefined' && typeof window.loadAppsFromStorage === 'function') {
        apps = window.loadAppsFromStorage();
        console.log('✅ Loaded apps from storage:', apps.length);
    } else if (typeof loadAppsFromStorage === 'function') {
        apps = loadAppsFromStorage();
        console.log('✅ Loaded apps (direct):', apps.length);
    } else {
        // Fallback: try to get from APPS_DATABASE
        if (typeof window !== 'undefined' && window.APPS_DATABASE) {
            apps = window.APPS_DATABASE;
            console.log('✅ Loaded apps from APPS_DATABASE:', apps.length);
        } else {
            console.warn('⚠️ No apps found, using empty array');
        }
    }
    
    if (apps.length === 0) {
        container.innerHTML = `
            <div class="no-apps-message">
                <p>No apps yet! Click "Add New App" to get started.</p>
            </div>
        `;
        return;
    }
    
    container.innerHTML = apps.map(app => `
        <div class="app-item-editor">
            <div class="app-item-info">
                <h4>${app.icon || '💻'} ${app.name}</h4>
                <p>${app.description}</p>
                <small style="color: var(--gray);">${app.category} • ${app.url}</small>
            </div>
            <div class="app-item-actions">
                <button class="btn-edit" onclick="editApp(${app.id})">
                    <i class="fas fa-edit"></i> Edit
                </button>
                <button class="btn-delete" onclick="deleteApp(${app.id})">
                    <i class="fas fa-trash"></i> Delete
                </button>
            </div>
        </div>
    `).join('');
}

function showAddAppForm() {
    console.log('➕ Showing add app form...');
    const modal = document.getElementById('appFormModal');
    const form = document.getElementById('appForm');
    const title = document.getElementById('appFormTitle');
    
    console.log('Form elements:', { modal, form, title });
    
    if (modal && form && title) {
        form.reset();
        const appIdInput = document.getElementById('appId');
        if (appIdInput) appIdInput.value = '';
        title.textContent = '➕ Add New App';
        modal.classList.add('active');
        console.log('✅ Add app form shown');
    } else {
        console.error('❌ Form elements not found!', { modal: !!modal, form: !!form, title: !!title });
    }
}

function closeAppForm() {
    const modal = document.getElementById('appFormModal');
    if (modal) {
        modal.classList.remove('active');
    }
}

function editApp(appId) {
    const apps = typeof loadAppsFromStorage === 'function' ? loadAppsFromStorage() : [];
    const app = apps.find(a => a.id === appId);
    
    if (!app) return;
    
    const modal = document.getElementById('appFormModal');
    const form = document.getElementById('appForm');
    const title = document.getElementById('appFormTitle');
    
    if (modal && form && title) {
        // Fill form with app data
        document.getElementById('appId').value = app.id;
        document.getElementById('appName').value = app.name;
        document.getElementById('appDescription').value = app.description;
        document.getElementById('appUrl').value = app.url;
        document.getElementById('appIcon').value = app.icon || '';
        document.getElementById('appCategory').value = app.category;
        document.getElementById('appImage').value = app.image || '';
        document.getElementById('appTags').value = app.tags ? app.tags.join(', ') : '';
        
        title.textContent = '✏️ Edit App';
        modal.classList.add('active');
    }
}

function saveApp(event) {
    event.preventDefault();
    console.log('💾 Saving app...');
    
    const form = event.target;
    const formData = new FormData(form);
    const appId = formData.get('id');
    
    const app = {
        id: appId ? parseInt(appId) : Date.now(),
        name: formData.get('name'),
        description: formData.get('description'),
        url: formData.get('url'),
        icon: formData.get('icon') || '💻',
        category: formData.get('category'),
        image: formData.get('image') || '',
        tags: formData.get('tags') ? formData.get('tags').split(',').map(t => t.trim()).filter(t => t) : [],
        featured: false,
        dateCreated: appId ? undefined : new Date().toISOString().split('T')[0],
        openInNewTab: true
    };
    
    console.log('App data:', app);
    
    // Get apps from storage
    let apps = [];
    if (typeof window !== 'undefined' && typeof window.loadAppsFromStorage === 'function') {
        apps = window.loadAppsFromStorage();
    } else if (typeof loadAppsFromStorage === 'function') {
        apps = loadAppsFromStorage();
    } else if (typeof window !== 'undefined' && window.APPS_DATABASE) {
        apps = [...window.APPS_DATABASE];
    }
    
    if (appId) {
        // Update existing app
        const index = apps.findIndex(a => a.id === parseInt(appId));
        if (index >= 0) {
            apps[index] = { ...apps[index], ...app };
            console.log('✅ Updated app at index', index);
        }
    } else {
        // Add new app
        apps.push(app);
        console.log('✅ Added new app, total apps:', apps.length);
    }
    
    // Save to storage
    if (typeof window !== 'undefined' && typeof window.updateAppsDatabase === 'function') {
        window.updateAppsDatabase(apps);
    } else if (typeof updateAppsDatabase === 'function') {
        updateAppsDatabase(apps);
    } else if (typeof window !== 'undefined' && typeof window.saveAppsToStorage === 'function') {
        window.saveAppsToStorage(apps);
        if (window.APPS_DATABASE) {
            window.APPS_DATABASE = apps;
        }
    }
    
    closeAppForm();
    loadAppsEditor();
    loadAppsGrid(); // Refresh the main grid
    
    showNotification(appId ? 'App updated successfully! ✨' : 'App added successfully! 🎉', 'success');
}

function deleteApp(appId) {
    if (!confirm('Are you sure you want to delete this app?')) {
        return;
    }
    
    let apps = typeof loadAppsFromStorage === 'function' ? loadAppsFromStorage() : [];
    apps = apps.filter(a => a.id !== appId);
    
    if (typeof updateAppsDatabase === 'function') {
        updateAppsDatabase(apps);
    }
    loadAppsEditor();
    loadAppsGrid(); // Refresh the main grid
    
    showNotification('App deleted successfully! 🗑️', 'success');
}

function exportApps() {
    const apps = typeof loadAppsFromStorage === 'function' ? loadAppsFromStorage() : [];
    const dataStr = JSON.stringify(apps, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'my-apps-backup.json';
    link.click();
    URL.revokeObjectURL(url);
    
    showNotification('Apps exported successfully! 📥', 'success');
}

function importApps() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'application/json';
    input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const imported = JSON.parse(event.target.result);
                if (Array.isArray(imported)) {
                    // Merge with existing apps (avoid duplicates by ID)
                    const existing = typeof loadAppsFromStorage === 'function' ? loadAppsFromStorage() : [];
                    const existingIds = new Set(existing.map(a => a.id));
                    const newApps = imported.filter(a => !existingIds.has(a.id));
                    
                    if (newApps.length === 0) {
                        showNotification('No new apps to import (all already exist)', 'info');
                        return;
                    }
                    
                    const merged = [...existing, ...newApps];
                    if (typeof updateAppsDatabase === 'function') {
                        updateAppsDatabase(merged);
                    }
                    loadAppsEditor();
                    loadAppsGrid();
                    showNotification(`Imported ${newApps.length} app(s) successfully! 📤`, 'success');
                } else {
                    throw new Error('Invalid format');
                }
            } catch (error) {
                showNotification('Error importing apps. Please check the file format.', 'error');
            }
        };
        reader.readAsText(file);
    };
    input.click();
}

// Close modals when clicking outside
document.addEventListener('click', (e) => {
    const appsEditorModal = document.getElementById('appsEditorModal');
    const appFormModal = document.getElementById('appFormModal');
    
    if (appsEditorModal && e.target === appsEditorModal) {
        closeAppsEditor();
    }
    
    if (appFormModal && e.target === appFormModal) {
        closeAppForm();
    }
});

function animateNumber(element, target) {
    if (!element) return;
    
    let current = 0;
    const increment = target / 50;
    const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
            current = target;
            clearInterval(timer);
        }
        element.textContent = Math.floor(current) + '+';
    }, 50);
}

function personalizeContent() {
    // This could be expanded to load from localStorage or API
    const defaultName = 'Little Star';
    const savedName = localStorage.getItem('childName') || defaultName;
    
    if (elements.heroName) {
        elements.heroName.textContent = savedName;
    }
    
    // Update page title
    document.title = `🌟 ${savedName}'s Creative World 🌟`;
}

// === UTILITY FUNCTIONS === //
function scrollToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
    }
}

function viewCreation(title, image, description) {
    // Simple modal for viewing creation details
    const modal = document.createElement('div');
    modal.className = 'creation-modal';
    modal.innerHTML = `
        <div class="creation-modal-content">
            <span class="creation-close">&times;</span>
            <img src="${image}" alt="${title}">
            <h3>${title}</h3>
            <p>${description}</p>
        </div>
    `;
    
    document.body.appendChild(modal);
    modal.style.display = 'flex';
    
    // Close functionality
    modal.querySelector('.creation-close').addEventListener('click', () => {
        document.body.removeChild(modal);
    });
    
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            document.body.removeChild(modal);
        }
    });
}

function notifyWhenReady() {
    showNotification('Thanks! We\'ll let you know when the shop is ready! 🛍️✨', 'info');
}

function showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification ${type}`;
    notification.innerHTML = `
        <div class="notification-content">
            <span class="notification-message">${message}</span>
            <button class="notification-close">&times;</button>
        </div>
    `;
    
    // Add styles
    notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: var(--white);
        color: var(--dark-gray);
        padding: 1rem 1.5rem;
        border-radius: var(--radius-lg);
        box-shadow: var(--shadow-xl);
        z-index: 9999;
        animation: notification-slide-in 0.3s ease;
        max-width: 300px;
        border-left: 4px solid var(--primary-${type === 'success' ? 'green' : type === 'error' ? 'orange' : 'blue'});
    `;
    
    document.body.appendChild(notification);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
        if (notification.parentNode) {
            notification.style.animation = 'notification-slide-out 0.3s ease';
            setTimeout(() => {
                if (notification.parentNode) {
                    document.body.removeChild(notification);
                }
            }, 300);
        }
    }, 5000);
    
    // Close button functionality
    notification.querySelector('.notification-close').addEventListener('click', () => {
        if (notification.parentNode) {
            document.body.removeChild(notification);
        }
    });
}

function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
    });
}

// === SCROLL EFFECTS === //
function initializeScrollEffects() {
    // Parallax effect for hero background
    window.addEventListener('scroll', handleParallaxEffect);
    
    // Update active section in navigation
    window.addEventListener('scroll', updateActiveSection);
}

function handleParallaxEffect() {
    const scrolled = window.pageYOffset;
    const heroBackground = document.querySelector('.hero-background');
    
    if (heroBackground) {
        heroBackground.style.transform = `translateY(${scrolled * 0.5}px)`;
    }
}

function updateActiveSection() {
    const sections = document.querySelectorAll('section[id]');
    const scrollPos = window.scrollY + 100;
    
    sections.forEach(section => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;
        const sectionId = section.getAttribute('id');
        
        if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
            updateActiveNavLink(`#${sectionId}`);
            currentSection = sectionId;
        }
    });
}

// === INTERACTIVE ELEMENTS === //
function initializeInteractiveElements() {
    // Add click effects to emoji shapes
    document.querySelectorAll('.shape').forEach(shape => {
        shape.addEventListener('click', () => {
            createFloatingEmoji(shape.textContent);
        });
    });
    
    // Add hover effects to cards
    document.querySelectorAll('.album-card, .contact-card, .social-link').forEach(card => {
        card.addEventListener('mouseenter', () => {
            card.style.transform = 'translateY(-5px) scale(1.02)';
        });
        
        card.addEventListener('mouseleave', () => {
            card.style.transform = 'translateY(0) scale(1)';
        });
    });
}

function createFloatingEmoji(emoji) {
    const floatingEmoji = document.createElement('div');
    floatingEmoji.textContent = emoji;
    floatingEmoji.style.cssText = `
        position: fixed;
        font-size: 2rem;
        pointer-events: none;
        z-index: 9999;
        animation: float-away 2s ease-out forwards;
    `;
    
    // Position at cursor
    floatingEmoji.style.left = event.clientX + 'px';
    floatingEmoji.style.top = event.clientY + 'px';
    
    document.body.appendChild(floatingEmoji);
    
    // Remove after animation
    setTimeout(() => {
        if (floatingEmoji.parentNode) {
            document.body.removeChild(floatingEmoji);
        }
    }, 2000);
}

// === ADD MISSING STYLES === //
const additionalStyles = `
    @keyframes float-away {
        0% {
            opacity: 1;
            transform: translateY(0) scale(1);
        }
        100% {
            opacity: 0;
            transform: translateY(-100px) scale(1.5);
        }
    }
    
    .creation-item {
        transition: all 0.3s ease;
    }
    
    .creation-card {
        background: var(--white);
        border-radius: var(--radius-lg);
        overflow: hidden;
        box-shadow: var(--shadow-md);
        transition: all 0.3s ease;
    }
    
    .creation-card:hover {
        transform: translateY(-5px);
        box-shadow: var(--shadow-xl);
    }
    
    .creation-image {
        position: relative;
        height: 200px;
        overflow: hidden;
    }
    
    .creation-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease;
    }
    
    .creation-card:hover .creation-image img {
        transform: scale(1.1);
    }
    
    .creation-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
    }
    
    .creation-card:hover .creation-overlay {
        opacity: 1;
    }
    
    .view-creation-btn {
        background: var(--primary-pink);
        color: var(--white);
        border: none;
        border-radius: var(--radius-full);
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    .view-creation-btn:hover {
        background: var(--primary-purple);
        transform: scale(1.1);
    }
    
    .creation-info {
        padding: var(--spacing-md);
    }
    
    .creation-info h4 {
        font-family: var(--font-heading);
        color: var(--primary-purple);
        margin-bottom: var(--spacing-xs);
    }
    
    .creation-info p {
        color: var(--gray);
        font-size: 0.9rem;
    }
    
    .adventure-item {
        margin-bottom: var(--spacing-xl);
        position: relative;
    }
    
    .adventure-item::before {
        content: '';
        position: absolute;
        left: 50%;
        top: 0;
        bottom: 0;
        width: 2px;
        background: var(--gradient-rainbow);
        transform: translateX(-50%);
    }
    
    .adventure-item.left .adventure-card {
        margin-right: 60%;
    }
    
    .adventure-item.right .adventure-card {
        margin-left: 60%;
    }
    
    .adventure-card {
        background: var(--white);
        border-radius: var(--radius-lg);
        overflow: hidden;
        box-shadow: var(--shadow-lg);
        position: relative;
    }
    
    .adventure-image {
        height: 200px;
        overflow: hidden;
    }
    
    .adventure-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .adventure-content {
        padding: var(--spacing-lg);
    }
    
    .adventure-date {
        background: var(--primary-yellow);
        color: var(--white);
        padding: var(--spacing-xs) var(--spacing-sm);
        border-radius: var(--radius-sm);
        font-size: 0.8rem;
        font-weight: 600;
        display: inline-block;
        margin-bottom: var(--spacing-sm);
    }
    
    .adventure-content h4 {
        font-family: var(--font-heading);
        color: var(--primary-purple);
        margin-bottom: var(--spacing-xs);
    }
    
    .creation-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }
    
    .creation-modal-content {
        background: var(--white);
        border-radius: var(--radius-lg);
        padding: var(--spacing-xl);
        max-width: 500px;
        max-height: 80vh;
        overflow-y: auto;
        position: relative;
        text-align: center;
    }
    
    .creation-close {
        position: absolute;
        top: 15px;
        right: 20px;
        font-size: 2rem;
        cursor: pointer;
        color: var(--gray);
    }
    
    .creation-modal-content img {
        width: 100%;
        max-width: 400px;
        border-radius: var(--radius-md);
        margin-bottom: var(--spacing-md);
    }
    
    .creation-modal-content h3 {
        font-family: var(--font-heading);
        color: var(--primary-purple);
        margin-bottom: var(--spacing-sm);
    }
`;

// Add the additional styles to the page
const styleSheet = document.createElement('style');
styleSheet.textContent = additionalStyles;
document.head.appendChild(styleSheet);

// === ERROR HANDLING === //
window.addEventListener('error', (e) => {
    console.error('An error occurred:', e.error);
    // Could implement error reporting here
});

// === THEME TOGGLE FUNCTIONALITY === //
function initializeThemeToggle() {
    console.log('🔍 Looking for theme toggle button...');
    const themeToggle = document.getElementById('themeToggle');
    
    if (!themeToggle) {
        console.warn('❌ Theme toggle button not found!');
        return;
    }
    
    console.log('✅ Theme toggle button found!');
    
    // Check for saved theme preference or default to light mode
    const savedTheme = localStorage.getItem('theme') || 'light';
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    console.log('💾 Saved theme:', savedTheme);
    
    // Apply initial theme
    if (savedTheme === 'dark' || (savedTheme === 'auto' && prefersDark)) {
        document.body.classList.add('dark-mode');
        updateThemeToggleText(true);
        console.log('🌙 Applied dark mode on load');
    } else {
        updateThemeToggleText(false);
        console.log('☀️ Applied light mode on load');
    }
    
    // Theme toggle click handler
    themeToggle.addEventListener('click', (e) => {
        console.log('🖱️ Theme toggle clicked!');
        e.preventDefault();
        toggleTheme();
    });
    
    // Listen for system theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
        if (localStorage.getItem('theme') === 'auto') {
            document.body.classList.toggle('dark-mode', e.matches);
            updateThemeToggleText(e.matches);
        }
    });
    
    console.log('🌙 Theme toggle initialized successfully!');
}

function toggleTheme() {
    const isDarkMode = document.body.classList.contains('dark-mode');
    const newTheme = isDarkMode ? 'light' : 'dark';
    
    // Toggle the theme
    document.body.classList.toggle('dark-mode');
    
    // Save preference
    localStorage.setItem('theme', newTheme);
    
    // Update toggle button
    updateThemeToggleText(!isDarkMode);
    
    // Create magical transition effect
    createThemeTransition(!isDarkMode);
    
    // Show notification
    const message = isDarkMode ? 'Welcome back to daylight! ☀️' : 'Entering Space Mode! 🌙✨';
    showNotification(message, 'info');
    
    console.log(`🎨 Theme switched to ${newTheme} mode`);
}

function updateThemeToggleText(isDark) {
    const toggleText = document.querySelector('.toggle-text');
    const themeToggle = document.getElementById('themeToggle');
    
    if (toggleText) {
        toggleText.textContent = isDark ? 'Day Mode' : 'Space Mode';
    }
    
    if (themeToggle) {
        themeToggle.title = isDark ? 'Switch to Day Mode' : 'Enter Space Mode';
    }
}

function createThemeTransition(toDark) {
    // Create a magical transition overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 9999;
        background: ${toDark ? 'radial-gradient(circle, #1e1b4b, #0f172a)' : 'radial-gradient(circle, #fbbf24, #f59e0b)'};
        opacity: 0;
        transition: opacity 0.5s ease;
    `;
    
    document.body.appendChild(overlay);
    
    // Animate the overlay
    setTimeout(() => {
        overlay.style.opacity = '0.8';
    }, 10);
    
    setTimeout(() => {
        overlay.style.opacity = '0';
    }, 300);
    
    // Remove overlay
    setTimeout(() => {
        if (overlay.parentNode) {
            overlay.parentNode.removeChild(overlay);
        }
    }, 800);
    
    // Add sparkle effects
    if (toDark) {
        createStarBurst();
    } else {
        createSunBurst();
    }
}

function createStarBurst() {
    const starCount = 15;
    
    for (let i = 0; i < starCount; i++) {
        setTimeout(() => {
            const star = document.createElement('div');
            star.innerHTML = '⭐';
            star.style.cssText = `
                position: fixed;
                left: ${Math.random() * window.innerWidth}px;
                top: ${Math.random() * window.innerHeight}px;
                font-size: ${Math.random() * 20 + 15}px;
                pointer-events: none;
                z-index: 9998;
                animation: starBurst 2s ease-out forwards;
            `;
            
            document.body.appendChild(star);
            
            setTimeout(() => {
                if (star.parentNode) {
                    star.parentNode.removeChild(star);
                }
            }, 2000);
        }, i * 100);
    }
}

function createSunBurst() {
    const sunCount = 10;
    
    for (let i = 0; i < sunCount; i++) {
        setTimeout(() => {
            const sun = document.createElement('div');
            sun.innerHTML = '☀️';
            sun.style.cssText = `
                position: fixed;
                left: ${Math.random() * window.innerWidth}px;
                top: ${Math.random() * window.innerHeight}px;
                font-size: ${Math.random() * 25 + 20}px;
                pointer-events: none;
                z-index: 9998;
                animation: sunBurst 1.5s ease-out forwards;
            `;
            
            document.body.appendChild(sun);
            
            setTimeout(() => {
                if (sun.parentNode) {
                    sun.parentNode.removeChild(sun);
                }
            }, 1500);
        }, i * 80);
    }
}

// Add animation keyframes for theme transitions
const themeAnimations = `
    @keyframes starBurst {
        0% {
            opacity: 0;
            transform: scale(0) rotate(0deg);
        }
        50% {
            opacity: 1;
            transform: scale(1.2) rotate(180deg);
        }
        100% {
            opacity: 0;
            transform: scale(0.8) rotate(360deg);
        }
    }
    
    @keyframes sunBurst {
        0% {
            opacity: 0;
            transform: scale(0);
        }
        50% {
            opacity: 1;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    }
`;

// Add animation styles to the page
const themeStyleSheet = document.createElement('style');
themeStyleSheet.textContent = themeAnimations;
document.head.appendChild(themeStyleSheet);

// === EXPORT FOR TESTING === //
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        CONFIG,
        scrollToSection,
        showNotification,
        formatDate,
        toggleTheme
    };
}

// === EXPOSE FUNCTIONS TO GLOBAL SCOPE FOR ONCLICK HANDLERS === //
if (typeof window !== 'undefined') {
    window.toggleAppsEditor = toggleAppsEditor;
    window.closeAppsEditor = closeAppsEditor;
    window.showAddAppForm = showAddAppForm;
    window.closeAppForm = closeAppForm;
    window.editApp = editApp;
    window.saveApp = saveApp;
    window.deleteApp = deleteApp;
    window.exportApps = exportApps;
    window.importApps = importApps;
    window.scrollToSection = scrollToSection;
    window.viewCreation = viewCreation;
    window.notifyWhenReady = notifyWhenReady;
}
